import React, { Component, useEffect, useState } from "react";
import Slider from "react-slick";

class SimpleSlider extends Component<any, any> {
  render() {
    const settings = {
      dots: false,
      infinite: true,
      arrows: false,
      speed: 3500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3500,
    };

    return (
      <div>
        <Slider {...settings}>
          <div>
            <h1>322 亿美元</h1>
            <h2>2018年全球半导体材料市场规模</h2>
          </div>
          <div>
            <h1>52.164 亿美元</h1>
            <h2>2018年中国半导体材料市场规模</h2>
          </div>
          <div>
            <h1>54.096 亿美元</h1>
            <h2>2018年韩国半导体材料市场规模</h2>
          </div>
          <div>
            <h1>70.84 亿美元</h1>
            <h2>2018年中国台湾半导体材料市场规模</h2>
          </div>
          <div>
            <h1>47.656亿美元</h1>
            <h2>2018年日本半导体材料市场规模</h2>
          </div>
          <div>
            <h1>23.828亿美元</h1>
            <h2>2018年欧洲半导体材料市场规模</h2>
          </div>
          <div>
            <h1>34.776亿美元</h1>
            <h2>2018年北美半导体材料市场规模</h2>
          </div>
        </Slider>
      </div>
    );
  }
}
export default SimpleSlider;
